import React, { useContext, useMemo } from 'react';
import './_changeLog.scss';
import ChangeLogTag from './ChangeLogTag';
import { dayjs } from '../../../utils/dayjs-utils';
import TakeMeThere from './TakeMeThere';
import ChangeLogSectionImage from './ChangeLogSectionImage';
import { ChangeLogContext } from './ChangeLogDrawer';
import { saralPurple } from '../../../utils/constants';
import ChangeLogSectionVideo from './ChangeLogSectionVideo';
import { useSelector } from 'react-redux';

const ChangeLogSection = ({ sectionInfo, onClose, index }) => {
  const { setRef, activeSection } = useContext(ChangeLogContext);
  const { list } = useSelector((state) => state.changelog);

  const isLast = list.length === index + 1;
  const isActive = useMemo(() => Boolean(activeSection === index), [activeSection, index]);

  return (
    <div
      ref={(ref) => {
        setRef(index, ref);
      }}
      className="change-log-section-container">
      <div style={{ position: 'relative' }}>
        <div
          className="change-log-section-line"
          style={{
            height: isLast && isActive && 'calc(100%)',
            borderRadius: isLast && isActive && '2px',
          }}
        />
        <div
          style={{ backgroundColor: activeSection >= index ? saralPurple : undefined }}
          className="change-log-section-dot"
        />
      </div>
      <div className="change-log-section-card">
        <ChangeLogTag tag={sectionInfo.tag} />

        <div className="change-log-section-header">
          <div className="change-log-section-title-container">
            <div className="change-log-section-title">{sectionInfo.title}</div>
          </div>
          <div className="change-log-section-date">{dayjs(sectionInfo.date).format('MMM DD, YYYY')}</div>
        </div>
        <div className="change-log-section-text">{sectionInfo.text}</div>
        <TakeMeThere navigateTo={sectionInfo?.navigateTo} onClose={onClose} />
        <ChangeLogSectionImage imageUrl={sectionInfo.imageUrl} title={sectionInfo.title} />
        <ChangeLogSectionVideo videoUrl={sectionInfo.videoUrl} thumbnail={sectionInfo.thumbnailUrl} />
      </div>
    </div>
  );
};

export default ChangeLogSection;
